exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-buttons.flex-container {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  margin: unset;\n  margin: none; }\n  .panel-buttons.flex-container a i.fa-close {\n    font-size: 1.2em; }\n\n.detail-header-section {\n  padding-top: 0;\n  margin-left: none;\n  margin-left: unset; }\n  .detail-header-section .route-info {\n    font-size: 18px; }\n    .detail-header-section .route-info span {\n      margin-left: 7px; }\n\n.detail-section .stop .badge .gap {\n  margin-left: 7px;\n  padding: 3px 5px;\n  background-color: rgba(199, 200, 202, 0.5);\n  border-radius: 2px; }\n  .detail-section .stop .badge .gap.tram-8 {\n    color: #ff6347; }\n  .detail-section .stop .badge .gap.tram-10 {\n    color: #00a1ff; }\n  .detail-section .stop .badge .gap.tram-64 {\n    color: #239e23; }\n\n.detail-section .stop .outer {\n  font-weight: 600; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/built-route-info-panel.component.scss
// module id = ../../../../../src/app/common/built-route-info-panel.component.scss
// module chunks = main